import React, { useState, useEffect } from "react";
import { Badges, H6, Image, LI, P, UL } from "../../../AbstractElements";
import SvgIcon from "../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";
import { CheckAll, Href, Notifications } from "../../../Utils/Constants";
import { dynamicImage } from "../../../Utils";
import {
  askForNotificationPermission,
  subscribeToPush,
  checkSubscription,
} from "../../../services/PushNotifications";
import { useSelector } from "react-redux";

export default function NotificationBox() {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const { notifications } = useSelector((state) => state.app);

  useEffect(() => {
    checkSubscription().then((subscription) => {
      setIsSubscribed(subscription);
    });
  }, []);

  const handleNotificationClick = async () => {
    const subscriptionStatus = await checkSubscription();
    if (subscriptionStatus) {
      console.log("Already subscribed");
    } else {
      const permission = await askForNotificationPermission();
      if (permission === "granted") {
        const subscription = await subscribeToPush();
        console.log("New subscription:", subscription);
        // Assuming you have a function to send subscription to server
        // sendSubscriptionToServer(subscription);
      } else {
        console.error("Notification permission denied.");
      }
    }
  };

  return (
    <LI className="onhover-dropdown">
      <div
        className="notification-box onhover-click"
        onClick={handleNotificationClick}
      >
        <i className="fa fa-bell" style={{ color: "white" }}></i>
        <Badges color="success" pill style={{ color: "white" }}>
          {notifications.length}
        </Badges>
      </div>
      <div className="onhover-show-div notification-dropdown">
        <H6 className="f-18 mb-0 dropdown-title">{"New Orders"} </H6>
        <UL className="simple-list">
          {notifications.map((item) => (
            <LI className="d-flex" key={item.id}>
              <div className="notification-image"></div>
              <div>
                <P>
                  <span className="f-w-500 me-1">
                    {item.type.toUpperCase()}
                  </span>
                  {item.text}
                </P>
                <span className="f-light">{item.time}</span>
              </div>
            </LI>
          ))}
          <LI>
            <a className="f-w-700" href={"/orders"}>
              {"All Orders"}
            </a>
          </LI>
        </UL>
      </div>
    </LI>
  );
}
